import React, { useState, useCallback, useEffect } from 'react';
import { PopularPackage } from '../hs-grad/popularPackage';
import { Breadcrumb } from '../breadcrumb';
import GradPackageTabs from '../hs-grad/gradPackageTabs';
import HeroBanner from '../hs-grad/heroBanner';
import FilterColCatalog from './filterColCatalog';
import { TitleBar } from '../packageBrowseTitle';
import {
    BREADCRUMB,
    HELPBUTTON,
    HEROBANNER,
    FILTERCOLCATALOG,
    PACKAGEGRID,
    PAGETITLE,
    POPULARPACKAGE,
} from '../../constants/rootElements';
import { HelpButton } from "../help";
import { gaPackageBrowsePageLoad } from '../../util/googleAnalytics';
import { TEMPLATES } from '../../constants';
import { renderPromoMessages } from '../promoMessages';
import { useFeeAlertInjectionScript, useGoogleAnalyticsHandler } from '../../hooks';

export const ColGradPackages = (props) => {
	const { packageBrowseData, pageContentData, affiliationData } = props.appData;
	const [gradPackageGroupData, setGradPackageGroupData] = useState({});
    const [breadCrumbData, setBreadCrumbData] = useState({});
    const [promoMessages, setPromoMessages] = useState([]);
	const [popularPackageItems, setPopularPackageItems] = useState([]);
	const [popularPackage, setPopularPackage] = useState('');
    const [collections, setCollections] = useState([]);
    const [degrees, setDegrees] = useState([]);
    const [selectedCollection, setSelectedCollection] = useState({});
    const [selectedDegree, setSelectedDegree] = useState({});
    const [subCatalogs, setSubCatalogs] = useState([]);
    const [isDegreeSelected, setIsDegreeSelected] = useState(false);
    const [templateName, setTemplateName] = useState();
    const [feeAlertRequestData, setFeeAlertRequestData] = useState(null);
    const [googleAnalyticsRequestData, setGoogleAnalyticsRequestData] = useState(null);

    useFeeAlertInjectionScript(feeAlertRequestData)
    const googleAnalytics = useGoogleAnalyticsHandler(googleAnalyticsRequestData);

    const isHighSchoolGraduation = templateName === TEMPLATES.HS_GRAD

	const PBBreadcrumb = pageContentData?.find(
		(data) => data.contentType === 'Navigation'
	);
	const HsHeroBanner = pageContentData?.find(
		(data) => data.contentType === 'GradPackageBrowseBanner'
	);
	const HsPopularPackage = pageContentData?.find(
		(data) => data.contentType === 'MascotPackage'
	);
	const HsPackages = pageContentData?.find(
		(data) => data.contentType === 'Packages'
	);
	const HsPageTitle = pageContentData?.find(
		(data) => data.contentType === 'ProductBrowseTitle'
	);
	const GradAnncPaymentPromo = pageContentData?.find(
		(data) => data.contentType === 'PaymentPromo'
    );
    const ProductBrowsePromoMsg = Boolean(
		pageContentData?.find(
			(data) => data.contentType === 'ProductBrowsePromoMsg'
		)
	);
    
    useEffect(() => {
        if(Object.keys(packageBrowseData)?.length>0) {
            Object.keys(packageBrowseData)?.forEach((mainKey) => {
                if(mainKey === 'metaData') return;

                if(packageBrowseData[mainKey]?.subCatalogRefKeys?.length>0) {
                    const customerNumber = packageBrowseData.metaData.customerNumber
                    const catalog = packageBrowseData[mainKey]
                    catalog?.subCatalogRefKeys?.forEach((subCatalogRefKey, index) => {
                        subCatalogRefKey["label"] = subCatalogRefKey.catalogName;
                        subCatalogRefKey["value"] = "collection"+index;
                    })                    
                    setPromoMessages(
                        catalog?.promoMessages
                    );
                    setFeeAlertRequestData({
                        containerSelector: '#promoMsg',
                        customerId: customerNumber,
                        catalogOsr: catalog?.catalogOsr,
                    })
                    setGoogleAnalyticsRequestData({
                        customerNumber,
                        publishedCatalogId: catalog?.publishedCatalogId,
                        sourceCatalogType: catalog?.sourceCatalogType,
                        catalogOsr: catalog?.catalogOsr,
                        customerClassCode: affiliationData?.customerClassCode
                    });
                    setCollections(catalog?.subCatalogRefKeys);
                    if(catalog?.subCatalogRefKeys?.length==1) {
                        setSelectedCollection(catalog?.subCatalogRefKeys[0]);
                    }
                } else {
                    console.log("No Collection Available");
                    setCollections([]);
                }
                if(Object.keys(packageBrowseData[mainKey]?.subCatalogs)?.length>0) {
                    let subCatalogs = [];
                    Object.keys(packageBrowseData[mainKey]?.subCatalogs)?.forEach((subCatalogKey) => {
                        let tempObj = {};
                        tempObj["subCatalogKey"] = subCatalogKey;
                        tempObj["subCatalogObject"] = {...packageBrowseData[mainKey]?.subCatalogs[subCatalogKey]};
                        subCatalogs.push(tempObj);
                    })
                    let key = Object.keys(subCatalogs[0]?.subCatalogObject?.productGroups)[0];
                    setBreadCrumbData({...subCatalogs[0]?.subCatalogObject?.productGroups[key]});
                    setSubCatalogs(subCatalogs);
                } else {
                    console.log("No Subcatalogs Available");
                    setSubCatalogs([]);
                }
            })
        }
    }, [packageBrowseData])

    useEffect(() => {        
        subCatalogs?.forEach((subCatalog, index) => {
            if(selectedCollection?.catalogKey === subCatalog?.subCatalogKey) {
                if(Object.keys(subCatalog?.subCatalogObject?.productGroups)?.length>0) {
                    if(Object.keys(subCatalog?.subCatalogObject?.productGroups)?.length==1) {
                        let key = Object.keys(subCatalog?.subCatalogObject?.productGroups)[0];
                        let obj = {...subCatalog?.subCatalogObject?.productGroups[key]};
                        obj["label"] = subCatalog?.subCatalogObject?.productGroups[key]?.displayName;
                        obj["value"] = "degree"+index;
                        setDegrees(obj);
                        setSelectedDegree(obj);
                        setIsDegreeSelected(true);
                        showPackageBrowseBanner();
                    } else {
                        let degrees = [];
                        Object.keys(subCatalog?.subCatalogObject?.productGroups)?.forEach((productGroupKey, index1) => {
                            let obj = {...subCatalog?.subCatalogObject?.productGroups[productGroupKey]};
                            obj["label"] = subCatalog?.subCatalogObject?.productGroups[productGroupKey].displayName;
                            obj["value"] = "degree"+index1;
                            degrees.push(obj);
                        })
                        setDegrees(degrees);
                        setIsDegreeSelected(false);
                        setSelectedDegree({});
                        hidePackageBrowseBanner();
                    }
                } else {
                    console.log("No Degrees Available");
                    setDegrees([]);
                    setIsDegreeSelected(false);
                    setSelectedDegree({});
                    hidePackageBrowseBanner();
                }
            }
        })
    }, [selectedCollection])

	useEffect(() => {
        if (selectedDegree.products?.length > 0) {
            setGradPackageGroupData(selectedDegree);
            let mostPopular = selectedDegree.products?.find((product) => product?.mostPopular)
            // select most expencive if no most popular defined
            mostPopular = mostPopular || selectedDegree.products.reduce((acc, product) => {
                const accPrice = acc.packagePrice ? Number(acc.packagePrice) : 0
                const productPice = product.packagePrice ? Number(product.packagePrice) : 0
                return accPrice < productPice ? product : acc 
            }, {})
            const productOsr = mostPopular?.publishedCatalogProductId;
            setPopularPackage(mostPopular);
            const packageOsrItems = [];
            selectedDegree.packageItems?.length > 0 &&
                selectedDegree.packageItems.map((packages) => {
                    if(packages.displayName !== "freeProducts") {
                        packages.packageProductAvailability.map((prodAvail) => {
                            if (prodAvail.packageOsr === productOsr) {
                                packageOsrItems.push(packages);
                            }
                            return true;
                        });
                    }
                    setPopularPackageItems(packageOsrItems);
                    return true;
                });
            setIsDegreeSelected(true);
            showPackageBrowseBanner();
        } else {
            setGradPackageGroupData({});
            setIsDegreeSelected(false);
            hidePackageBrowseBanner();
        }
    }, [selectedDegree]);

    useEffect(() => {
        window?.template && setTemplateName(window.template)
    }, [])
    
    const showPackageBrowseBanner = () => {
        if(document.getElementsByClassName("package-browse-banner") && document.getElementsByClassName("package-browse-banner")[0]) {
            document.getElementsByClassName("package-browse-banner")[0].style.display='block';
        }
        if(document.getElementById("package-browse-banner-bottom-hr")) {
            document.getElementById("package-browse-banner-bottom-hr").style.display="block"
        }
    }

    const hidePackageBrowseBanner = () => {
        if(document.getElementsByClassName("package-browse-banner") && document.getElementsByClassName("package-browse-banner")[0]) {
            document.getElementsByClassName("package-browse-banner")[0].style.display='none';
        }
        if(document.getElementById("package-browse-banner-bottom-hr")) {
            document.getElementById("package-browse-banner-bottom-hr").style.display="none"
        }
    }

	const getBreadcrumb = useCallback(() => {
		BREADCRUMB.render(<Breadcrumb pbData={breadCrumbData} />);
    }, [breadCrumbData]);
    
    const getPromoMsg = useCallback(() => {
		renderPromoMessages(promoMessages)
	}, [promoMessages]);

	const getPopularPackage = useCallback(() => {
		POPULARPACKAGE.render(
			<PopularPackage
				firstPackageName={popularPackage?.displayName}
				packageItems={popularPackageItems}
                hsPopularPackage={HsPopularPackage}
                isDegreeSelected={isDegreeSelected}
			/>
		);
	}, [popularPackage, popularPackageItems, HsPopularPackage, isDegreeSelected ]);

	const getHeroBanner = useCallback(() => {
		HEROBANNER.render(
			<HeroBanner
				pageContentData={HsHeroBanner}
                hsPaymentPromo={GradAnncPaymentPromo}
                packageGroupData={gradPackageGroupData}
				popularPackage={popularPackage}
				repMessage={popularPackage?.repMessage}
                firstPackageName={popularPackage?.displayName}
                altImage={HsPopularPackage?.imageUrl}
                fromGradPackages={true}
                isDegreeSelected={isDegreeSelected}
                heading={selectedDegree?.label}
                googleAnalytics={googleAnalytics}
			/>
		);
	}, [
		HsHeroBanner,
		GradAnncPaymentPromo,
		gradPackageGroupData,
        popularPackage,
        isDegreeSelected,
        selectedDegree,
        googleAnalytics
	]);
	
    const getFilterColCatalog = useCallback(() => {
        let catalog = {}
        Object.keys(packageBrowseData).forEach((mainKey) => {
            if(mainKey === 'metaData') return;
            catalog = packageBrowseData[mainKey];
        })

		FILTERCOLCATALOG.render(
			<FilterColCatalog
                catalog={catalog}
                collections={collections}
                selectedCollection={selectedCollection}
                setSelectedCollection={setSelectedCollection}
                degrees={degrees}
                selectedDegree={selectedDegree}
                setSelectedDegree={setSelectedDegree}
			/>
		);
	}, [
        packageBrowseData,
        selectedDegree,
        selectedCollection,
        collections,
        degrees
	]);

	const getGradPackage = useCallback(() => {
		gradPackageGroupData?.packageItems?.length > 0 &&
			gradPackageGroupData?.products?.length > 0 &&
			PACKAGEGRID.render(
					<GradPackageTabs
						packageList={gradPackageGroupData?.packageItems?.filter(
							(obj) => obj.packageProductAvailability?.length > 0
						)}
						productList={gradPackageGroupData?.products}
						pageContentData={HsPackages}
                        altImage={HsPopularPackage?.imageUrl}
                        fromGradPackages={true}
                        isDegreeSelected={isDegreeSelected}
                        googleAnalytics={googleAnalytics}
					/>
			);
	}, [gradPackageGroupData, HsPackages, isDegreeSelected, googleAnalytics]);

	const getTitleBar = useCallback(() => {
		PAGETITLE.render(
			<TitleBar pageContent={HsPageTitle} affiliationData={affiliationData} />
		);
	}, [HsPageTitle, affiliationData]);

	const getHelpButton = useCallback(() => {
		HELPBUTTON.render(<HelpButton />);
	}, [])

	useEffect(()=>{
		gaPackageBrowsePageLoad();
	},[])

	return (
		<div className='container-fluid'>
			{HsPageTitle && Object.keys(HsPageTitle)?.length > 0 && getTitleBar()}
            {ProductBrowsePromoMsg && promoMessages?.length > 0 && getPromoMsg()}
			{PBBreadcrumb &&
				breadCrumbData &&
				Object.keys(breadCrumbData)?.length > 0 &&
				getBreadcrumb()}
			{HsHeroBanner && getHeroBanner()}
			{getFilterColCatalog()}
			{HsPopularPackage && isHighSchoolGraduation && getPopularPackage()}
			{HsPackages && getGradPackage()}
			{getHelpButton()}
		</div>
	);
};